import React, { useContext, useRef } from "react";
import styles from "./AskConsentButton.module.scss";
import TranslationsContext from "src/contexts/TranslationsContext";
import { newMetricsWithContext } from "src/utils/metricsUtils";
import { NativeAPI } from "src/utils/deviceUtils";
import useImpressionCallback from "src/utils/useImpressionCallback";

type PropTypes = {
    metadata: QuickViewAsinMetadata;
    isMiniHeader?: boolean;
};

const AskConsentButton: React.FC<PropTypes> = ({ metadata, isMiniHeader }: PropTypes) => {
    const translations = useContext(TranslationsContext);
    const a11yTarget = useRef<HTMLButtonElement>(null);
    const metrics = newMetricsWithContext(isMiniHeader ? "AskConsentButton.miniHeader" : "AskConsentButton", metadata.asin);
    const displayString = metadata?.primaryPurchaseBuyingOption?.callToAction?.entity?.askConsent?.data?.displayString ?? translations.getText("ask-consent-cta-display-string");

    useImpressionCallback(a11yTarget, () => metrics.recordMetricOnce("AskConsentButton.Render", 1));

    const handleClick = () => {
        metrics.recordBehavioralMetric("AskConsentButton.click", 1);
        NativeAPI.openTeenAccountError(metadata);
    };

    return (
        <button type="button" className={styles.askConsentButton} onClick={handleClick} ref={a11yTarget}>
            <div className={styles.label}>{displayString}</div>
        </button>
    );
};

export default AskConsentButton;
